/**
 * User Status Service
 *
 * DEPRECATED: Subscription-related functions removed.
 * Use the new subscription service and hooks instead:
 *
 * Migration guide:
 * - Old: UserSignedInAndSubscriptionActive(cognitoUser)
 * - New: useHasActiveSubscription() hook
 *
 * - Old: subscriptionIsCurrent(cognitoUser)
 * - New: useHasActiveSubscription() hook
 *
 * See: src/services/subscription/subscriptionStatusService.js
 * See: src/hooks/useSubscriptionStatus.js
 */

// Basic user check (still needed for authentication)
export function CognitoUserSignedIn(cognitoUser) {
  try {
    return cognitoUser && cognitoUser["username"] !== undefined;
  } catch (error) {
    return false;
  }
}

// Re-export for any remaining imports (will be removed in future)
export {
  isSubscriptionActive,
  isSubscriptionCancelling,
  isSubscriptionInactive,
  isSubscriptionExpired,
  isEligibleToSubscribe
} from '../subscription/subscriptionStatusService';
